import React, { useCallback, useState } from 'react';
import { Route, RouteComponentProps, Switch } from 'react-router-dom';
import LookupForm from './LookupForm';
import OtpVerification from '../OtpVerification';
import Redirect from 'components/Redirect';
import { selectCreditApplication } from 'state/creditApplication';
import { useSelector } from 'react-redux';
import { pick } from 'ramda';

export interface FormValues {
  mobilePhone: string;
  ssn?: string;
  zip?: string;
}

export type PropTypes = RouteComponentProps & {
  onOtpSuccessful: (values: {
    ssn?: string;
    zip?: string;
    mobilePhone: string;
    otpCode: string;
  }) => Promise<void>;
};

const PhoneValidation: React.FC<PropTypes> = props => {
  const { onOtpSuccessful, match } = props;
  const creditApplication = useSelector(selectCreditApplication);

  const prefillValues = pick(
    ['mobilePhone', 'ssn', 'zip'],
    creditApplication,
  ) as FormValues;

  const [values, setValues] = useState<FormValues>(prefillValues);

  const handleOtpSuccess = useCallback(
    async (otpCode: string) => {
      await onOtpSuccessful({
        ssn: values.ssn,
        zip: values.zip,
        mobilePhone: values.mobilePhone,
        otpCode,
      });
    },
    [values, onOtpSuccessful],
  );

  return (
    <Switch>
      <Route
        path={`${match.path}`}
        exact
        render={routeProps => (
          <LookupForm
            {...routeProps}
            onSubmit={setValues}
            values={values}
            showSsn={!values.ssn}
            showZip={!values.zip}
          />
        )}
      />
      {values.mobilePhone ? (
        <Route
          path={`${match.path}/otp-verification`.replace('//', '/')}
          render={routeProps => (
            <OtpVerification
              {...routeProps}
              onOtpSuccessful={handleOtpSuccess}
              values={values}
            />
          )}
        />
      ) : (
        <Redirect
          from={`${match.path}/otp-verification`.replace('//', '/')}
          to={match.path}
        />
      )}
    </Switch>
  );
};

export default PhoneValidation;
